module.exports = __webpack_public_path__ + "static/media/supportIcon.1920ac98.png";